import { CURRENT_CONFIG } from '/@/api/http/config'

export const AMapConfig = {
  key: CURRENT_CONFIG.amapKey,
  version: '2.0',
  plugins: [
    'AMap.Scale',
    'AMap.ToolBar',
    'AMap.ControlBar',
    'AMap.ElasticMarker',
    'AMap.MapType',
    'AMap.Geocoder',
    'AMap.CircleEditor',
    'AMap.PolygonEditor',
    'AMap.PolylineEditor',
    'AMap.PolyEditor',
    'AMap.RangingTool',
    'AMap.Weather',
    'AMap.MouseTool',
    'AMap.MoveAnimation',
    'AMap.GeoJSON',
    'AMap.PlaceSearch',
    'AMap.AutoComplete'
  ]
}

// 机器人媒体文件基础 URL
// export const ROBOT_MEDIA_BASE_URL = import.meta.env.VITE_APP_ENVIRONMENT === 'DEV'
//   ? 'https://robotsolution.cn:9002/dj-cloud-bucket'
//   : `${location.origin}/dj-cloud-bucket`

export const ROBOT_MEDIA_BASE_URL = '/dj-cloud-bucket'

/** 开发环境对外可访问的站点 origin，与 vite proxy target 一致 */
export const DEV_PUBLIC_ORIGIN = 'http://192.168.100.123'

// 机器狗wss前缀
export const WSS_BASE_URL = import.meta.env.VITE_APP_ENVIRONMENT === 'DEV'
? 'ws://robotsolution.cn'
: `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}`
